export class ReportIncomeEventType {

	static STEPS = {
		REPORT_INCOME_LIST: 'REPORT_INCOME_LIST',
		REPORT_INCOME_CONFIRMATION: 'REPORT_INCOME_CONFIRMATION',
		REPORT_INCOME_RESULT: 'REPORT_INCOME_RESULT'
	};


	static REPORT_INCOME = {
		CONFIRM_DATA: 'CONFIRM_DATA'
	};

	static ERROR = 'REPORT_INCOME_ERROR';
	static BUTTONS = 'REPORT_INCOME_BUTTONS';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/report-income/report-income.event.type.ts